import { Component, OnInit, Input } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { TransactionDetailModal } from '../../../../modals';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { FinanceService } from '../../../../services';
@Component({
	selector: 'app-admin-invoice-unit',
	templateUrl: './invoice-unit.component.html',
	styleUrls: [ './invoice-unit.component.scss' ]
})
export class InvoiceUnitComponent implements OnInit {
	@Input() customerNCCID: string;
	@Input() currency: string;
	@Input()
	set invoiceNumber(value: string) {
		if (value) {
			this.filter = new AppFilter({ sidx: 'dateCreated' });
			this.searchFilter.rules[0].data = value;
			this.filter.filters = JSON.stringify(this.searchFilter);
			this.filter._search = false;

			this.getPage(value);
		}
	}
	@Input() units: Array<any> = [ { name: 'Sample Unit', description: 'sample desc' } ];
	pending: boolean;
	filter: AppFilter;
	searchFilter = {
		groupOp: 'AND',
		rules: [
			{
				field: 'invoiceNumber',
				op: 'eq',
				data: ''
			}
		]
	};
	error: any;
	totalItems: number;
	rows: number;
	payments: Array<any> = [];
	constructor(private financeSvc: FinanceService, private modalService: SuiModalService) {}

	getPage(id: string) {
		// set the page number from the caller
		this.pending = true;
		this.error = null;
		this.financeSvc.getInvoiceTransactions({ id: id, params: {} }).subscribe(
			(res: any) => {
				this.pending = false;
				this.payments = res;
			},
			(error) => {
				this.pending = false;
				this.error = error.error;
			}
		);
	}
	view(unit) {
		this.modalService
			.open(new TransactionDetailModal('Transaction Detail', unit, ModalSize.Tiny))
			.onApprove((payload) => {})
			.onDeny(() => {});
	}
	onChange(event, equipment) {}
	getApplication() {}
	ngOnInit(): void {
		// this.viewCert();
		// console.log(
		// 	JSON.parse(localStorage.getItem('userData'))['appUser']['organization']['organizationTypeId'][
		// 		'organizationTypeId'
		// 	]
		// );
	}
}
